// src/features/auth/authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDashboardService } from '../../api/dashboard/index';

const getDashboard = createAsyncThunk(
    'dashboard/getData',
    async (credentials, { rejectWithValue }) => {
        try {
            const data = await getDashboardService();
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Something went wrong');
        }
    }
);

const initialState = {
    user: null,
    token: null,
    loading: false,
    error: null,
    showotp: true,
    data: []
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {

    },
    extraReducers: builder => {
        builder
            .addCase(getDashboard.pending, state => {
                state.loading = true;
                state.error = null;
                state.showotp = true
            })
            .addCase(getDashboard.fulfilled, (state, action) => {

                state.loading = false;
                state.showotp = false
                // state.token = action.payload.token;
                state.data = action.payload.data
                state.userDetail = action.payload.data.userDetail
                // localStorage.setItem('token', action.payload.token);
            })
            .addCase(getDashboard.rejected, (state, action) => {
                state.loading = false;
                state.showotp = true
                state.error = action.payload;
                state.data = null
            })


    },
});

export const { logout, setuserDetail } = authSlice.actions;
export { getDashboard }
export default authSlice.reducer;
